import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
import { CBQQuestionDTO } from "./InitCBQQuestion";

export interface UpdateCBQQuestionPayload {
  prompt?: string;
  helpText?: string;
  optionsJson?: Record<string, unknown>;
  correctAnswerJson?: Record<string, unknown>;
  points?: number;
}

type UpdateCBQQuestionResponse = {
  statusCode?: number;
  error?: null | ApiError;
  data?: CBQQuestionDTO;
};

export const UpdateCBQQuestion = async ({
  questionId,
  payload,
}: {
  questionId: string;
  payload: UpdateCBQQuestionPayload;
}): Promise<UpdateCBQQuestionResponse> => {
  try {
    const response = await axios.patch(
      `/admin/cbq/questions/${questionId}`,
      payload
    );
    return { data: response.data?.data ?? response.data };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
